import {createContext, useReducer, Dispatch, ReactNode} from 'react';

const initialState: NotificationsStateProps = {
	studentsWithoutFlowCount: 0,
	studentsWithoutGroupCount: 0,
	answeredAssignmentsWithoutMark: [],
	changedAssignmentsWithoutMark: [],
	unconfirmedExamMarksCount: 0,
	groupsWithoutFlowCount: 0,
	groupsWithoutFlowIDs: [],
	libraryBookings: [],
	cancelInProcessBenefit: 0,
	pendingScores: 0,
	pendingBenefits: 0
};

export interface NotificationsStateProps {
	studentsWithoutFlowCount: number;
	studentsWithoutGroupCount: number;
	changedAssignmentsWithoutMark: number[];
	answeredAssignmentsWithoutMark: number[];
	unconfirmedExamMarksCount: number;
	groupsWithoutFlowCount: number;
	groupsWithoutFlowIDs: number[];
	libraryBookings?: any[];
	cancelInProcessBenefit?: number;
	pendingScores?: number;
	pendingBenefits?: number;
}

type Action =
	| {type: 'GET_NOT_ATTACHED_STUDENTS'; payload: NotificationsStateProps}
	| {type: 'LIBRARY_BOOKING_MARK_READ'; payload: number};

interface InitContextProps {
	state: NotificationsStateProps;
	dispatch: Dispatch<Action>;
}

export const NotificationsContext = createContext({} as InitContextProps);

const reducer = (state: NotificationsStateProps, action: Action) => {
	switch (action.type) {
		case 'GET_NOT_ATTACHED_STUDENTS':
			return {
				...state,
				studentsWithoutFlowCount: action.payload.studentsWithoutFlowCount,
				changedAssignmentsWithoutMark: action.payload.changedAssignmentsWithoutMark,
				answeredAssignmentsWithoutMark: action.payload.answeredAssignmentsWithoutMark,
				studentsWithoutGroupCount: action.payload.studentsWithoutGroupCount,
				unconfirmedExamMarksCount: action.payload.unconfirmedExamMarksCount,
				groupsWithoutFlowCount: action.payload.groupsWithoutFlowCount,
				groupsWithoutFlowIDs: action.payload.groupsWithoutFlowIDs,
				libraryBookings: action.payload.libraryBookings ?? state.libraryBookings ?? [],
				cancelInProcessBenefit: action.payload.cancelInProcessBenefit ?? state.cancelInProcessBenefit ?? 0,
				pendingScores: action.payload.pendingScores ?? state.pendingScores ?? 0,
				pendingBenefits: action.payload.pendingBenefits ?? state.pendingBenefits ?? 0
			};
		case 'LIBRARY_BOOKING_MARK_READ':
			return {
				...state,
				libraryBookings: state.libraryBookings?.filter(n => n.id !== action.payload)
			};
		default:
			return state;
	}
};

const NotificationsProvider = ({children}: {children: ReactNode}) => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const value = {state, dispatch};

	return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>;
};

export default NotificationsProvider;
